























import Vue from 'vue'
import RangeSlider from '@/common/components/RangeSlider.vue'

export default Vue.extend({
  components: {
    RangeSlider
  },
  props: {
    minVal: {
      type: Number,
      default: 0
    },
    maxVal: {
      type: Number,
      default: 0
    },
    minThreshold: {
      type: Number,
      required: true
    },
    maxThreshold: {
      type: Number,
      required: true
    }
  },
  data(): {
    minInputValidate: boolean
    maxInputValidate: boolean
  } {
    return {
      minInputValidate: false,
      maxInputValidate: false
    }
  },
  computed: {
    validateRangeValue(): boolean {
      return (
        this.minInputValidate && this.maxInputValidate
      )
    },
    resetFilter(): boolean {
      return (
        this.minVal == this.minThreshold &&
        this.maxVal == this.maxThreshold
      )
    }
  },
  watch: {
    validateRangeValue(value: boolean) {
        this.$emit('onUpdateRangeValidate', value)
      }
    },
  methods: {
    rangeValuesHandler(value: {[key: string]: number}){
      this.$emit('updateParams', {
        minUnitPrice: value.min,
        maxUnitPrice: value.max
      })
    },
    minInputValidateHandler(value: boolean) {
      this.minInputValidate = value
    },
    maxInputValidateHandler(value: boolean) {
      this.maxInputValidate = value
    }
  }

})
